import { type InboxItem, InboxItemType } from '@seen/core/models/inbox'
import type { ReactNode } from 'react'
import { match } from 'ts-pattern'

import type { NotificationItem } from '#src/hooks/useNotificationItems.ts'
import { CommentMentionInboxItemRow } from '#src/pages/inbox/CommentMentionInboxItemRow.tsx'
import { FaxErrorInboxItemRow } from '#src/pages/inbox/FaxErrorInboxItemRow.tsx'
import { NewCommentInboxItemRow } from '#src/pages/inbox/NewCommentInboxItemRow.tsx'
import { NewCommentReplyInboxItemRow } from '#src/pages/inbox/NewCommentReplyInboxItemRow.tsx'
import { NewProposedAppointmentInboxItemRow } from '#src/pages/inbox/NewProposedAppointmentInboxItemRow.tsx'
import { OrderSignedInboxItemRow } from '#src/pages/inbox/OrderSignedInboxItemRow.tsx'
import { TaskAssignedInboxItemRow } from '#src/pages/inbox/TaskAssignedInboxItemRow.tsx'
import { TaskDueInboxItemRow } from '#src/pages/inbox/TaskDueInboxItemRow.tsx'
import { TaskNewCommentInboxItemRow } from '#src/pages/inbox/TaskNewCommentInboxItemRow.tsx'

export interface InboxItemRowProps {
  item: InboxItem
  notificationItem: NotificationItem
  onSelect?: () => void
  isSelected?: boolean
  sidebarOpen?: boolean
}

export function InboxItemRow({
  item,
  notificationItem,
  onSelect,
  isSelected,
  sidebarOpen,
}: InboxItemRowProps): ReactNode {
  return match(item)
    .with({ type: InboxItemType.TaskAssigned }, (item) => (
      <TaskAssignedInboxItemRow
        item={item}
        notificationItem={notificationItem}
        onSelect={onSelect}
        isSelected={isSelected}
        sidebarOpen={sidebarOpen}
      />
    ))
    .with({ type: InboxItemType.TaskDue }, (item) => (
      <TaskDueInboxItemRow
        item={item}
        notificationItem={notificationItem}
        onSelect={onSelect}
        isSelected={isSelected}
        sidebarOpen={sidebarOpen}
      />
    ))
    .with({ type: InboxItemType.TaskNewComment }, (item) => (
      <TaskNewCommentInboxItemRow
        item={item}
        notificationItem={notificationItem}
        onSelect={onSelect}
        isSelected={isSelected}
        sidebarOpen={sidebarOpen}
      />
    ))
    .with({ type: InboxItemType.NewProposedAppointment }, (item) => (
      <NewProposedAppointmentInboxItemRow
        item={item}
        notificationItem={notificationItem}
        onSelect={onSelect}
        isSelected={isSelected}
        sidebarOpen={sidebarOpen}
      />
    ))
    .with({ type: InboxItemType.NewComment }, (item) => (
      <NewCommentInboxItemRow
        item={item}
        notificationItem={notificationItem}
        onSelect={onSelect}
        isSelected={isSelected}
        sidebarOpen={sidebarOpen}
      />
    ))
    .with({ type: InboxItemType.NewCommentReply }, (item) => (
      <NewCommentReplyInboxItemRow
        item={item}
        notificationItem={notificationItem}
        onSelect={onSelect}
        isSelected={isSelected}
        sidebarOpen={sidebarOpen}
      />
    ))
    .with({ type: InboxItemType.CommentMention }, (item) => (
      <CommentMentionInboxItemRow
        item={item}
        notificationItem={notificationItem}
        onSelect={onSelect}
        isSelected={isSelected}
        sidebarOpen={sidebarOpen}
      />
    ))
    .with({ type: InboxItemType.OrderSigned }, (item) => (
      <OrderSignedInboxItemRow
        item={item}
        notificationItem={notificationItem}
        onSelect={onSelect}
        isSelected={isSelected}
        sidebarOpen={sidebarOpen}
      />
    ))
    .with({ type: InboxItemType.FaxError }, (item) => (
      <FaxErrorInboxItemRow
        item={item}
        notificationItem={notificationItem}
        onSelect={onSelect}
        isSelected={isSelected}
        sidebarOpen={sidebarOpen}
      />
    ))
    .exhaustive()
}
